
<div class="p-4 md:p-6 lg:p-8">
    <div class="border-2 border-dashed surface-border border-round surface-card" style="min-height: 20rem"></div>
</div>